import { Injectable } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { KeywordsService } from '../lobby/keywords.service';
import { LobbyNavigator } from '../lobby/lobby-navigator.service';
import { UserSessionService } from '../user-session/user-session.service';
import { UtilsService } from '../utils/utils.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { checkRedirectLoggedInRoutesName, checkRedirectLoggedOutRoutesName } from 'src/app/components/menu/factory';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { LobbyService } from '../lobby/lobby.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class RedirectService {

  public href: string = "";

  constructor(
    public events: EventsService,
    public keywordService: KeywordsService,
    public lobbyNavigator: LobbyNavigator,
    public navigator: Navigator,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public utilsService: UtilsService,
    public userSessionService: UserSessionService,
    public webcontentService: WebcontentService,
    public appStorageService: AppstorageTsService,
    private gameHubControllerService: GameHubControllerService,
    private lobbyService: LobbyService,
    private platform: Platform,
    public config: ConfigService
  ) { }

  public checkForRedirects(): any {
    let url = document.location.href;

    if (url.indexOf('#paypal') > -1) {
      this.events.publish("event:lobby:hide");
      this.events.publish("event:notification:suspend");
      return this.navigator.navigateTo("DepositPaypalComponent", {}, {paypalResult: parent.window.location.search.slice(1), paypalHashValue: url});
    }

    if (url.indexOf('#interac-return') > -1) {
      this.events.publish("event:lobby:hide");
      this.events.publish("event:notification:suspend");
      return this.navigator.navigateTo("DepositInteracActionPage", {}, { interacReturn: url });
    }

    if (url.indexOf('#password_reset') > -1 || url.indexOf('#password_forgot') > -1) {
      this.events.publish("event:lobby:hide");
      let twoFactor = this.config.getConfig().FEATURE_MFA_ON_EMAIL ?? 0;

      if(twoFactor == 1 || twoFactor == "1"){
        return this.navigator.navigateTo("ResetPasswordMFAComponent", {}, {tokenURL: url});
      } else {
        return this.navigator.navigateTo("ResetPasswordComponent", {}, {tokenURL: url});
      }
    }

    if (url.indexOf('#upload_customer_documents') > -1) {
      this.events.publish("event:lobby:hide");
      return this.navigator.navigateTo("SecureUplodDocumentComponent", {}, {tokenURL: url});
   }
    
    if (url.indexOf('#game_launch') > -1) {
      this.gameLaunch(url);
    }
  }

  public gameLaunch(url) {
    console.log('Is it Game Launch URL ---', url);
      let authCheckForUser: boolean;
      if (!this.platform.is('capacitor') && localStorage.getItem('userSession.sessionToken') !== null) {
        authCheckForUser = true;
      } else if (this.platform.is('capacitor') && sessionStorage.getItem('userSession.sessionToken') !== null) {
        authCheckForUser = true;
      } else {
        authCheckForUser = false;
      }
      const pathValue = this.extractPathValue(url);
      console.log('Game Launch Value:', pathValue);
      const gameObject = { id: null, game_name: null };

      if (pathValue) {
        const [id, game_name] = pathValue.split('/');
        gameObject.id = id;
        gameObject.game_name = game_name;
        console.log('Extracted Game Object:', gameObject);
        if (authCheckForUser) {
          setTimeout(() => {
            return this.gameHubControllerService.launchCasinoGame(gameObject);
          }, 500);
        } else {
          this.lobbyService.setWaitingGameData(gameObject);
          return this.navigator.navigateTo("LoginComponent");
        }
      }
  }

  public extractPathValue(url) {
    // Check if the URL contains the fragment '#game_launch'
    const fragmentIndex = url.indexOf('#game_launch');
    if (fragmentIndex !== -1) {
      let pathStartIndex = fragmentIndex + '#game_launch'.length + 1;
      let pathValue = url.substring(pathStartIndex);
      pathValue = decodeURIComponent(pathValue);
      return pathValue;
    }
    return null;
  }

  public navigateBasedOnPathName(): any {
    let pageName = window.location.pathname;

    //Adding Special Check to consume quereyparams case ---START---
    let checkQueryParams = parent.window.location.search.slice(1);
    if (checkQueryParams) {
      //console.log('I will skip other calls in this function', checkQueryParams);
      let urlParts = pageName.split("/");
      const stub = urlParts[1];
      if (stub == 'c' && typeof urlParts[2] === 'string') {
        return this.webcontentService.updateExternalLink(urlParts[2]);
      }
      return;
    }
    //Adding Special Check to consume quereyparams case ---END---

    if (pageName && pageName.indexOf('localhost') > -1) {
      pageName = '/';
    }

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }

    let urlParts = pageName.split("/");
    const stub = urlParts[0];
    //console.log(urlParts)
    if (stub == 'launcher') return this.navigator.toCasino();

    if (stub == 'livedealer') return this.liveDealerRedirectAction();

    if (stub == 'promotions') {
      return  this.promotionRedirectAction();
    }

    if (stub == 'game' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      this.navigator.toWebview();
      return setTimeout(() => this.navigator.pushHistoryState("game/" + urlParts[1]), 1000);
    };

    //webview page redirect logic
    if (stub == 'c' && typeof urlParts[1] === 'string') {
      //this.webcontentService.updateExternalLink(urlParts[1]);
      //this.navigator.toWebview();
      //return setTimeout(() => this.navigator.pushHistoryState("c/" + urlParts[1]), 1000);
      this.webcontentService.updateExternalLink(urlParts[1]);
      this.navigator.toWebview(false, urlParts[1]);
      //Special check to select My Free Spin keyword for deeplink
      if(urlParts[1] === 'my-bonus-spin' || urlParts[1] === 'my-free-spin') this.freeSpinRedirectAction(urlParts[1]);
    }

    //Casino Keywords page redirect logic
    switch (this.config.getDeafaultRoute()) {
      case "/":
        if (stub == 'casino' && typeof urlParts[1] === 'string') {
          this.navigator.toTab("casino", false, urlParts[1]);
          this.lobbyNavigator.toKeyTabRoute(urlParts[1])
        }
        break;
      case "casino":
        if (stub == 'casino' && typeof urlParts[1] === 'string') {
          this.navigator.toTab("casino", false, urlParts[1]);
          this.lobbyNavigator.toKeyTabRoute(urlParts[1])
        }
        break;
      case "casino/valley-forge":
        if (stub == 'casino' && urlParts[1] == 'valley-forge' && typeof urlParts[2] === 'string') {
          this.navigator.toTab("casino/valley-forge", false, urlParts[2]);
          this.lobbyNavigator.toKeyTabRoute(urlParts[2])
        }
        break;
      default:
        if (stub == 'casino' && typeof urlParts[1] === 'string') {
          this.navigator.toTab("casino", false, urlParts[1]);
          this.lobbyNavigator.toKeyTabRoute(urlParts[1])
        }
        break;
    }
    /*if (stub == 'login') {
      this.navigator.toCasino();
      return this.navigator.navigateTo('LoginComponent');
    };

    if (stub == ('signup' || 'join')) {
      this.navigator.toCasino();
      return this.navigator.navigateTo('SignupOptionsComponent');
    };*/

    //All other modal component logic based on user authentication
    //Below logic includes redirect on page refresh
    let authCheckForUser: boolean;
    if (localStorage.getItem('userSession.sessionToken') !== null) {
      authCheckForUser = true;
    } else {
      authCheckForUser = false;
    }
    if (stub != "/") {
      let pageToLoad;
      //Special Check for WP Pages to accomodate new authentication related check
      if (stub == 'c' && typeof urlParts[1] === 'string') {
        this.webcontentService.updateExternalLink(urlParts[1]);
        return this.navigator.toWebview(false, urlParts[1]);
      }

      //Casino Keywords page redirect logic
      //console.log(urlParts[1])
      //if (stub == 'casino' && typeof urlParts[1] === 'string') {
      // return this.lobbyNavigator.toKeyTabRoute(urlParts[1])
      //}

      if (authCheckForUser) {
        pageToLoad = checkRedirectLoggedInRoutesName(stub);
        if (!!pageToLoad) {
          this.router.navigate(['/casino'], { skipLocationChange: true });
          return this.navigator.navigateTo(pageToLoad);
        }
        return this.router.navigate(['/casino'], { skipLocationChange: false });
      } else {
        pageToLoad = checkRedirectLoggedOutRoutesName(stub);
        if (!!pageToLoad) {
          this.router.navigate(['/casino'], { skipLocationChange: true });
          return this.navigator.navigateTo(pageToLoad);
        }
        return this.router.navigate(['/casino'], { skipLocationChange: false });
      }
    } else {
      this.navigator.toCasino();
    }  

  }

  public mobileRedirectBasedOnPathName() {
    let pageName = window.location.pathname;    
    if (pageName == '/launcher') return this.navigator.toCasino();
  }

  public updateDefaultKeywordSelection(){
    let key: object = {
      action_param: "Home",
      action_type: "gamelist",
      name: "Home"
    };

   return setTimeout(() => this.lobbyNavigator.selectKeyword(key), 200);
  }

  public browserReloadActions(tabName): void {

    switch (tabName) {
      case 'promotions':
        this.promotionRedirectAction();
        break;
      case 'livedealer':
        this.liveDealerRedirectAction();
        break;
      default:
        this.checkForRedirects();
        this.navigateBasedOnPathName();
        break;
    }
  }

  private liveDealerRedirectAction() {
    this.navigator.toCasino();
    setTimeout(() => {
      this.keywordService.getLiveDealerKeywordInfo().subscribe(res => {
        if(res){
          return this.lobbyNavigator.selectKeyword(res);
        }
      }).unsubscribe();
    }, 300);
   
  }

  private promotionRedirectAction() {

    let key: object = {
      action_param: "promotions",
      action_type: "internalnav",
      name: "Promotions"
    };

    return setTimeout(() => this.lobbyNavigator.selectKeyword(key), 200);
  }

  private freeSpinRedirectAction(pathName) {

    let key: object = {
      action_param: pathName,
      action_type: "externalpageload",
      name: "Free Spin"
    };

    return setTimeout(() => this.lobbyNavigator.selectKeyword(key), 200);
  }

  public getTabNames(tabName): boolean {
    const Tabs: any = {
      "livedealer": "livedealer"
    }

    if (tabName in Tabs) return true; //Tabs[tabName]
    return false;
  }

  //AppsFlyer DeepLink for Mobile Apps
  checkUserStateSelector(deepLinkPath: any, deepLinkStateName: any) {
    this.appStorageService.getStardustJurisdiction().then((stardustJurisdictionResponse) => {
      const stardustJurisdiction = !!stardustJurisdictionResponse.value
        ? stardustJurisdictionResponse.value
        : "none";
      //If deep_link_sub1 which is deepLinkStateName param is not set 
      //than set the user preference for state and then load the deeplink path    
      if (stardustJurisdiction == 'none') {  
        console.log(deepLinkPath)
        console.log(deepLinkStateName)
        const deepLinkSub1: any = deepLinkStateName ? deepLinkStateName : "NJ";
        this.appStorageService.setStardustJurisdiction(deepLinkSub1).then(() => {
          this.config.reloadConfig().then(() => {
            return setTimeout(() => {
              console.log("skin: jurisdiction change ", deepLinkSub1);
              this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
            }, 1000);
          });
        });
      } else {
        //If deep_link_sub1 which is deepLinkStateName param is different 
        //value than user has already state selected then update the preference logic

        if (stardustJurisdiction == deepLinkStateName) {
          this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
        } else {
          setTimeout(() => {
            let selectedStateName;
            //deepLinkStateName is empty after venmo payment, then set the Jurisdiction from storage.
            if(deepLinkStateName) {
              selectedStateName = deepLinkStateName;
            } else {
              selectedStateName = stardustJurisdiction;
            }
            this.appStorageService.setStardustJurisdiction(selectedStateName).then(() => {
              this.config.reloadConfig().then(() => {
                return setTimeout(() => {
                  console.log("skin: jurisdiction change ", selectedStateName);
                  this.deepLinkActionForAppsFlyer(deepLinkPath, selectedStateName);
                }, 1000);
              });
            });
          }, 1000); //Added Timeout to finish the app's default re-directing to selected state
        }
        //If use has alreday state selector preference then 
        //ignore deep_link_sub1 which is deepLinkStateName param value
        //this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
      }
    })
  }

  //AppsFlyer DeepLink for Mobile Apps
  public deepLinkActionForAppsFlyer(pageName, stateName?): any {

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }
    let urlParts = pageName.split("/");
    const stub = urlParts[0];
    console.log(urlParts)

    //Login componenet Redirect Logic
    if (stub == 'login') {
      this.navigator.toCasino();
      return this.navigator.navigateTo('LoginComponent');
    };

    //Signup componenet Redirect Logic
    if (stub == 'signup' || stub == 'join') {
      let pageName = 'SignupOptionsComponent';
      if(stateName == "ON") {
        pageName = 'SignupStepOneComponent';
      }
      
      this.navigator.toCasino();
      return this.navigator.navigateTo(pageName);
    };

    //game info page redirect logic
    if (stub == 'game' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.navigator.toWebview();
        this.navigator.pushHistoryState("game/" + urlParts[1])
      }, 1500);
    };

    //webview page redirect logic
    if (stub == 'c' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.navigator.toWebview();
        this.navigator.pushHistoryState("c/" + urlParts[1])
      }, 1500);
    }

    //sports page redirect logic - future request

  }

}